import { ITextEntity } from '@shared/types';
import {
  highScoreFeedback,
  mediumScoreFeedback,
  lowScoreFeedback,
  highScoreFeedbackEn,
  mediumScoreFeedbackEn,
  lowScoreFeedbackEn,
} from '../config/feedback.config';

export interface GetNextOrPrevEntityParams {
  isNext: boolean;
  textEntities: ITextEntity[];
  selectedTextEntity: ITextEntity | null;
}



// פונקציה למציאת ישות טקסט הבאה או הקודמת
// עוסקת בניווט בין ישויות טקסט במערך.
export const getNextOrPrevEntity = ({
  isNext,
  textEntities,
  selectedTextEntity,
}: GetNextOrPrevEntityParams): ITextEntity => {
  const nextEntityIndex = textEntities.findIndex(
    (el) => el.index === selectedTextEntity?.index
  );
  let index = isNext ? nextEntityIndex + 1 : nextEntityIndex - 1;

  if (index === -1 && !isNext) index = textEntities?.length - 1;

  let nextEntity = textEntities[index >= 0 ? index : 0];
  if (!nextEntity) nextEntity = textEntities[0];

  return nextEntity;
};



// פונקציה לבחירת משפט אקראי לפי ציון ושפה
export const getRandomFeedback = (score: number, language: string = 'he'): [string, string?] => {
  const isEnglish = language === 'en';
  let feedbackArray: [string, string?][];

  if (score >= 81) {
    feedbackArray = isEnglish ? highScoreFeedbackEn : highScoreFeedback;
  } else if (score >= 51) {
    feedbackArray = isEnglish ? mediumScoreFeedbackEn : mediumScoreFeedback;
  } else {
    feedbackArray = isEnglish ? lowScoreFeedbackEn : lowScoreFeedback;
  }

  const randomIndex = Math.floor(Math.random() * feedbackArray.length);
  return feedbackArray[randomIndex];
};

export const adjustScale = (element: HTMLElement): void => {
  const maxHeight = 72;
  let scale = 1;

  while (element.scrollHeight > maxHeight && scale > 0.5) {
    scale -= 0.05;
    element.style.transform = `scale(${scale})`;
  }
};
